import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { HAS_WINDOW } from '../constants';
/**
 * Create an object from a query param string.
 * @param paramsString
 */

export function paramsToObj(paramsString) {
  return paramsString.replace(/(^\?)/, '').split('&').reduce(function (acc, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        val = _param$split2[1];

    if (key && val) return _extends({}, acc, _defineProperty({}, key, decodeURIComponent(val)));
    return acc;
  }, {});
}
/**
 * The browser query param string in object format
 */

export var queryParams = HAS_WINDOW ? paramsToObj(window.document.location.search) : {};
export var deleteQueryParam = function deleteQueryParam(param) {
  delete queryParams[param];
  var hasKeys = Object.keys(queryParams).length !== 0;
  window.history.replaceState({}, '', "".concat(window.document.location.origin).concat(window.document.location.pathname).concat(hasKeys ? "?".concat(new URLSearchParams(queryParams).toString()) : ''));
};
export var deleteAllQueryParams = function deleteAllQueryParams() {
  Object.keys(queryParams).forEach(function (key) {
    delete queryParams[key];
  });
  window.history.replaceState({}, '', "".concat(window.document.location.origin).concat(window.document.location.pathname));
};